import qs from 'qs'; // This file serves purpose to config qs module

export function queryParse(value) {
  var config = {};
  return qs.parse(value, config);
}
export function queryStringify(value) {
  var config = {};
  return qs.stringify(value, config);
}